// MalwareAssignmentItemSkeleton.js

import React from 'react';
import styled from 'styled-components';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

// Re-using the CardContainer from your original component for consistent styling
const CardContainer = styled.div`
    width: 100%;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border: 1px solid #dee2e6;
    padding: 1.5rem;
    @media (min-width: 768px) {
        padding: 2.5rem;
    }
`;

const MalwareAssignmentItemSkeleton = () => {

    return (
        <CardContainer className="container my-4">
            <input type="hidden" id="mobileNo" value="9804598859" />
            <div className="row g-4 ">
                {/* Left Column Skeleton */}
                <div className="col-lg-7">
                    <Skeleton variant="text" width="60%" height={48} />
                    
                    <Box sx={{ display: 'flex', gap: 3, my: 3 }}>
                        <Skeleton variant="text" width={150} height={24} />
                        <Skeleton variant="text" width={180} height={24} />
                        <Skeleton variant="text" width={220} height={24} />
                    </Box>

                    <hr className="my-4" />
                    
                    <Skeleton variant="text" width={150} height={32} />
                    <Skeleton variant="rectangular" width="100%" height={80} sx={{ mt: 1 }} />
                    
                    <Skeleton variant="text" width={150} height={32} sx={{ mt: 4 }}/>
                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        <Skeleton variant="rectangular" width={80} height={28} sx={{ borderRadius: '16px' }} />
                        <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '16px' }} />
                        <Skeleton variant="rectangular" width={70} height={28} sx={{ borderRadius: '16px' }} />
                    </Box>
                </div>

                {/* Right Column Skeleton */}
                <div className="col-lg-5">
                    <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                        <Skeleton variant="text" width={200} height={32} />
                        <Skeleton variant="text" width="90%" sx={{ mt: 2 }}/>
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="95%" />
                        
                        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: 1 }} />
                            <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: 1 }} />
                        </Box>

                        <hr className="my-4" />
                        
                        <Skeleton variant="text" width={180} height={28} />
                         <Skeleton variant="text" width="100%" sx={{ mt: 2 }}/>
                    </Box>
                </div>
            </div>
        </CardContainer>
    );
};

export default MalwareAssignmentItemSkeleton;